import React, { Component } from 'react';
import styled from 'styled-components';

import { COLORS } from '../../../assets/js/constants';
import { RadioButton } from '../../../deprecated/controls/radioButton';

const RadioGroupContainer = styled.div`
    flex-direction: ${props => props.direction ? props.direction : 'column'};
    width: ${props => props.bordered ? '100%' : 'auto'};
`;

const border = `1px solid ${COLORS.grey}`;

const RadioButtonContainer = styled.div`
    padding: 5px 0 8px;
    border-top: ${props => props.bordered ? border : 'none'};
    width: ${props => props.itemWidth ? props.itemWidth : 'auto'};
    &:last-of-type {
        border-bottom: ${props => props.bordered ? border : 'none'};
    }
`;

class RadioGroup extends Component {
    render() {
        const { bordered, direction, key, options, itemWidth, name, onChange, selectedValue } = this.props;
        return (
            <RadioGroupContainer bordered={bordered} direction={direction} key={key}>
                {
                    options.map(option =>
                        <RadioButtonContainer bordered={bordered}
                            key={option.id}
                            itemWidth={itemWidth}>
                            <RadioButton
                                name={name}
                                id={option.id}
                                value={option.value}
                                label={option.label}
                                onChange={onChange && onChange.bind(this, option.value)}
                                checked={selectedValue == option.value}
                                dataTest={option.dataTest} >
                            </RadioButton>
                        </RadioButtonContainer>)
                }
            </RadioGroupContainer>
        );
    }
}

export default RadioGroup;
